import { call, put } from "redux-saga/effects";
import { addItemFailure, addItemSuccess } from "../actions";
import { AddItemRequestProps, addItemRequest } from "../api";
import { ListFieldsKeys } from "src/api/config";

export function* addDefaultSaga<K extends ListFieldsKeys>(payload: AddItemRequestProps<K>) {
  try {
    if (payload) {
      const ID: number = yield call(addItemRequest, payload);
      return ID;
    }
  } catch (error) {
    console.log(error);
    yield put(addItemFailure({ listName: payload.listName, error }));
  }
}
